import { useEffect, useState } from "react";
import { IDataModal } from "../..";
import { ComplexAnimatedModal } from "../../../../ui/modal/ComplexAnimatedModal";
import FormRequest from "../forms/formRequest/formRequest";
import { toast } from "react-toastify";
import useDealRequest, {
  EDealRequestType,
} from "../../../../../api/hooks/use-deal-request";
import { IFillDataWizardSell } from "../../../sell/components/wizard";
import styles from "./styles.module.scss";
import { getAccessToken } from "../../../../../lib/services/localStorage.service";
import AuthModal from "../../../auth/components/modals/authModal";
import { useNavigate } from "react-router-dom";
import { PATHS } from "../../../../shared/constants";
import { EMarketTypes } from "../../../../../interfaces";
import useOpenModal from "../../../../ui/modal/hooks/useOpenModal";

interface IModalTradeInProps {
  isOpen: boolean;
  data: IDataModal;
  offsetY: number;
  onDismiss: (value: boolean) => void;
}
export interface IDataRansom {
  userApartmentNumber: string;
  apartmentType?: string;
  areaInSqM: string;
  address: string;
  buildingId: number;
  complexId?: number;
  streetId?: number;
  typeId?: number;
  estimatedPrice?: number;
}

const TEXT = `Компания Reit купит вашу квартиру в минимальный срок. Оставьте заявку, чтобы узнать на какую сумму за продажу вашей квартиры вы можете рассчитывать уже сегодня.
Укажите номер квартиры и оставьте заявку. Наш эксперт свяжется с вами для уточнения нюансов.`;

const ModalRansom = ({
  isOpen,
  data,
  offsetY,
  onDismiss,
}: IModalTradeInProps) => {
  const navigate = useNavigate();

  const {
    offsetY: offsetYAuth,
    open: openAuth,
    handleChangeModal: handleChangeModalAuth,
  } = useOpenModal();

  const initDataRansom = {
    userApartmentNumber: "",
    address: data.address ?? "",
    apartmentType: data.typeApartment,
    areaInSqM: data.areaInSqM ?? "",
    buildingId: data.buildingId ?? -1,
    complexId: data.complexId,
    streetId: data.streetId,
    typeId: data.facilityTypeId,
    estimatedPrice: data.estimatedPrice,
  };

  const [dataRansom, setDataRansom] = useState<IDataRansom>(initDataRansom);

  const onChangeData = (value: string, key: string) => {
    setDataRansom((prev) => ({ ...prev, [key]: value }));
  };

  const { error, isMutating, trigger } = useDealRequest();

  useEffect(() => {
    setDataRansom(initDataRansom);
  }, [isOpen]);

  const handleSubmit = async () => {
    if (getAccessToken()) {
      try {
        if (
          dataRansom.buildingId &&
          dataRansom.userApartmentNumber &&
          dataRansom.areaInSqM
        ) {
          await trigger({
            type: EDealRequestType.Ransom,
            data: {
              areaInSqM: Number(dataRansom.areaInSqM),
              buildingId: dataRansom.buildingId,
              apartmentNumber: Number(dataRansom.userApartmentNumber),
              complexId: dataRansom.complexId,
              streetId: dataRansom.streetId,
              typeId: dataRansom.typeId,
              estimatedPrice: dataRansom.estimatedPrice,
            } as Partial<IFillDataWizardSell>,
            marketType: EMarketTypes.SECONDARY,
          });
        }
        toast.success(
          "Ваша заявка принята, наш эксперт свяжется с вами в течении 2х часов в рабочее время."
        );
        onDismiss(false);
        navigate(`/${PATHS.myDeal}`);
      } catch (error: any) {
        if (error.message === "Unauthorized") {
          handleChangeModalAuth(true);
        }
      }
    } else {
      handleChangeModalAuth(true);
    }
  };

  return (
    <div>
      {openAuth && (
        <AuthModal
          opened={openAuth}
          onClose={() => handleChangeModalAuth(false)}
          offsetY={offsetYAuth}
        />
      )}
      <ComplexAnimatedModal
        opened={isOpen}
        onClose={() => onDismiss(false)}
        offsetY={offsetY}
      >
        <div className={styles.commonModalContainer}>
          <FormRequest
            title="Выкуп"
            text={TEXT}
            buttonLabel="Оставить заявку на выкуп"
            titleForPatForm={"Квартира выкупа:"}
            onClick={handleSubmit}
            type="sell"
            labelForApartment="Квартира:"
            data={dataRansom}
            onChange={onChangeData}
            isLoading={isMutating}
          />
        </div>
      </ComplexAnimatedModal>
    </div>
  );
};
export default ModalRansom;
